import { HttpClient } from "@angular/common/http";
import DataSource from "devextreme/data/data_source";
import { IChartContent, IChartSeries } from "../nica-chart-maker/IChartContent";

export const Mesi =[
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre'
];

export enum Statistiche{
  'distinta rif. c.e.r.',
  'riepilogo giornaliero/mensile',
  //'distinta rif. c.e.r. + tipol. + st.fisico',
  //'distinta rif. c.e.r. + riferimento',
  //'totale raggruppato per cliente',
  //'totale raggruppato per produttore',
   //'totale raggruppato per trasportatore',
   //'totale raggruppato per smaltitore'
}



export function getGraficoJSON(statistica:string,valore:string,dati?:any[],causaliOperazioni?:string[],sedi?:string[]):IChartContent{

    let json : IChartContent = {
        tipoGrafico:'torta',
        dati:[]
    };
    
 

    switch(statistica.toLowerCase()){

        case Statistiche[0]:{
            

            json.titolo = 'Distinta CER del '.concat(valore);


            for(let dato of dati){

                let series : IChartSeries[]= [{
                    name:valore,
                    value:valore.toLowerCase().includes('mov') ? Math.trunc(Math.random()*1000) : parseFloat((Math.random()*10000).toFixed(3)),
                    tooltip:dato.descrizione
                }];

                
               
                
                
                let datoo = {
                    gruppo:dato.id,
                    series:series
                };

                json.dati.push(datoo);
            }


        }break;
        /*
        case Statistiche[1]:{


        }break;
        case Statistiche[2]:{


        }break;
        */
        case Statistiche[1]:{

            
            json.titolo = 'Riepilogo Mensile del '.concat(valore);

       

            for(let mese of Mesi){

                let series : IChartSeries[]= [{
                    name:valore,
                    value:valore.toLowerCase().includes('mov') ? Math.trunc(Math.random()*1000) : parseFloat((Math.random()*10000).toFixed(3))
                }];

                
               
                
                
                let dato = {
                    gruppo:mese,
                    series:series
                };

                json.dati.push(dato);
            }
            


        }break;
        /*
        case Statistiche[4]:{


        }break;
        case Statistiche[5]:{


        }break;
        case Statistiche[6]:{


        }break;
        case Statistiche[7]:{


        }break;
        */

    }
    //console.log(json);

    return json;
}